module.exports = __webpack_public_path__ + "static/media/merchant-track-order.6a50154c.png";